// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2sAwh","itemTitle":"ClientEmergencyInfo_itemTitle__SK0B1","itemText":"ClientEmergencyInfo_itemText__2OM61"};